//
import PropTypes from "prop-types"
import genericFilterGroup from "shared/search/containers/FilterGroup/FilterGroups.js"

import {
    ReplyEmailFromAddressFilter,
    ReplyEmailForwardAddressFilter,
    ReplyEmailToAddressFilter,
    ReplyEmailTextFilter,
    ReplyEmailSubjectFilter,
    ReplyEmailCreatedDateNoFutureFilter,
    ReplyEmailCreatedDatePickerStartNoFutureFilter,
    ReplyEmailCreatedDatePickerEndNoFutureFilter,
    ReplyEmailSendEmailFilter,
    ReplyEmailOfficialsFilter,
    ReplyEmailStaffersFilter,
    ReplyEmailPressContactsFilter,
    ReplyEmailContactsFilter,
    ReplyEmailOfficialFilter,
    ReplyEmailStafferFilter,
    ReplyEmailOfficialsAndStaffersFilter,
    ReplyEmailPressContactFilter,
    ReplyEmailContactFilter,
    ReplyEmailTitleFilter,
    ReplyEmailContactOrganizationFilter,
    ReplyEmailEmailAddressFilter,
    ReplyEmailRecipientNameFilter,
} from "shared/search/containers/Filter/ReplyEmailFilters"

const defaultProps = {
    filters: PropTypes.array,
    uniqueFilterGroupId: PropTypes.string,
    displayLabel: PropTypes.string,
    helpText: PropTypes.string,
}

export const ReplyEmailSearchFilterGroup = (props) => genericFilterGroup(props)
ReplyEmailSearchFilterGroup.propTypes = defaultProps
ReplyEmailSearchFilterGroup.defaultProps = {
    filters: [
        ReplyEmailFromAddressFilter,
        ReplyEmailForwardAddressFilter,
        ReplyEmailToAddressFilter,
        ReplyEmailTextFilter,
        ReplyEmailSubjectFilter,
    ],
    uniqueFilterGroupId: "replyEmailSearchFilterGroup",
    displayLabel: "Search",
    helpText: "Filter reply emails by their metadata.",
}

export const ReplyEmailDateFilterGroup = (props) => genericFilterGroup(props)
ReplyEmailDateFilterGroup.propTypes = defaultProps
ReplyEmailDateFilterGroup.defaultProps = {
    filters: [
        ReplyEmailCreatedDateNoFutureFilter,
        ReplyEmailCreatedDatePickerStartNoFutureFilter,
        ReplyEmailCreatedDatePickerEndNoFutureFilter,
    ],
    uniqueFilterGroupId: "replyEmailDateFilterGroup",
    displayLabel: "Date",
    helpText: "Filter reply emails by their date of reply",
}

export const ReplyEmailSendEmailFilterGroup = (props) => genericFilterGroup(props)
ReplyEmailSendEmailFilterGroup.propTypes = defaultProps
ReplyEmailSendEmailFilterGroup.defaultProps = {
    filters: [
        ReplyEmailSendEmailFilter,
        ReplyEmailOfficialsFilter,
        ReplyEmailStaffersFilter,
        ReplyEmailPressContactsFilter,
        ReplyEmailContactsFilter,
    ],
    uniqueFilterGroupId: "replyEmailSendEmailFilterGroup",
    displayLabel: "Email",
    helpText: "Filter reply emails by their corresponding outbox email",
}

export const ReplyEmailSourceFilterGroup = (props) => genericFilterGroup(props)
ReplyEmailSourceFilterGroup.propTypes = {
    filters: PropTypes.array,
    uniqueFilterGroupId: PropTypes.string,
    displayLabel: PropTypes.string,
    helpText: PropTypes.string,
}
ReplyEmailSourceFilterGroup.defaultProps = {
    filters: [
        ReplyEmailOfficialFilter,
        ReplyEmailStafferFilter,
        ReplyEmailOfficialsAndStaffersFilter,
        ReplyEmailPressContactFilter,
        ReplyEmailContactFilter,

        ReplyEmailTitleFilter,
        ReplyEmailContactOrganizationFilter,
        ReplyEmailEmailAddressFilter,
        ReplyEmailRecipientNameFilter,
    ],
    uniqueFilterGroupId: "replyEmailSourceFilterGroup",
    displayLabel: "Source",
    helpText: "Filter reply emails by information related to their source",
}
